import { REDUX_CLOSE_MODAL, REDUX_OPEN_MODAL } from 'common/constants';

const initState = {
    isOpen: false,
    id: null,
    props: {}
};

const modalReducer = (state = initState, action) => {
    const { props, id } = action.payload || {};
    switch (action.type) {
        case REDUX_OPEN_MODAL:
            return {
                ...state,
                isOpen: true,
                id: id,
                props: props
            };
        case REDUX_CLOSE_MODAL:
            return {
                ...state,
                isOpen: false,
                id: id,
            };
        default:
            return state;
    }
};

export default modalReducer;
